/**
 * Rich Text Editor - MultiRow Toolbar Sample
 */
import Toolbar from './toolbar';
import React from 'react';
import './style.css';
import ProfilePicture from "profile-picture"
import "profile-picture/build/ProfilePicture.css"
import {   TextField ,Fab} from '@material-ui/core';
import {Button, Dropdown, FormControl,ProgressBar,DropdownButton} from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import Header from '../header';
export default class CV2 extends React.Component{
    constructor(props) {
        super(props)
    
        this.profilePictureRef = React.createRef();
      }
    handleUpload() {
        const PP = this.profilePicture.current;
        const imageData = PP.getData();
        const file = imageData.file;
        const imageAsDataURL = PP.getImageAsDataUrl();
    
       
        //add here the upload logic...
      }
render(){
return (
    <div style={{backgroundColor:"whitesmoke"}}>
        <Header/>
<Toolbar/>

<div  className="container" style={{borderStyle:"groove" ,marginTop:"40px",height:"1250px", backgroundColor:"white"}}>

    <div className="wrapper">
    
    <nav id="sidebar2"  >
        <div class="sidebar-header">
        <ProfilePicture
      ref={this.profilePictureRef}
      useHelper={true}
      debug={true}
    />

        </div>
<br/>
        <ul class="list-unstyled components" style={{ marginLeft:"18px"}}>
            <div className="contact">
            <h4><strong>CONTACT</strong></h4>
            <hr class="solid"/>
<div style={{display:"flex"}}>
<Icon.Phone size={35} style={{marginTop:'8px'}}/>
            <TextField 
            style={{color:"white"}}
                name="num_tel"
                variant="outlined"
                required
                id="num_tel"
                label="Numero de telephone "
                autoFocus/>
</div>
           <br/>
<div style={{display:"flex"}}>
<Icon.Mailbox size={35} style={{marginTop:'8px',marginRight:'4px'}}/>
            <TextField 
                name="mail"
                variant="outlined"
                required
                id="mail"
                label="Votre email "
                autoFocus/>
</div>
<br/>

<div style={{display:"flex"}}>
<Icon.CursorFill size={35} style={{marginTop:'8px',marginRight:'2px'}}/>
            <TextField 
            style={{color:"white"}}
                name="adresse"
                variant="outlined"
                required
                id="adresse"
                label="Votre Adresse "
                autoFocus/>
</div>
            </div>
            <br/>
           <div className="Skill">
<h4><strong>SKILLS</strong></h4>
<hr class="solid"/>
<div style={{display:"flex"}}>
<TextField 
            style={{color:"white"}}
                variant="outlined"
                required
                fullWidth
                id="skill"
                label="Votre Skill ex:photoshop "
                autoFocus/>
                  <TextField 
            style={{color:"white"}}
                variant="outlined"
                required
                style={{marginLeft:"30px",marginRight:"20px"}}
type="number"
                id="level"
                label="Votre niveau sur 100 "
                autoFocus/>
</div>
<br/>
<ProgressBar variant="dark" now={50} style={{marginRight:"20px"}} />
<Button variant="dark" style={{marginLeft:"202px",marginTop:"7px"}}>Add a skill</Button>
           </div>
<br/>
<div className="langages">
    <h4><strong>LANGAGES</strong></h4>
    <hr class="solid"/>
<div style={{display:"flex"}}>
<TextField 
            style={{color:"white"}}
                variant="outlined"
                required
                fullWidth
                id="langue"
                style={{marginRight:"10px"}}
                label="Saisissez votre langue "
                autoFocus/>
                <DropdownButton style={{marginRight:"20px"}} variant="secondary" id="dropdown_level_langage" title="Level of langue">
  <Dropdown.Item >Mother Langage</Dropdown.Item>
  <Dropdown.Item >Complete professionnel proficency</Dropdown.Item>
  <Dropdown.Item >Limited</Dropdown.Item>

  <Dropdown.Item >Basic Knowlegde</Dropdown.Item>
</DropdownButton>

</div>
<Button variant="dark" style={{marginLeft:"170px",marginTop:"7px"}}>Add a langage</Button>

</div>
        </ul>
    </nav>
<div id="content2_">
   
    <nav >
        <div >
        <p>Your name:</p>
        <TextField 
       
        autoComplete="fname"
                variant="outlined"
                required
                
                type="name"
                fullWidth
                id="name"
                label="Your fucking name"
                autoFocus/>
                <br/><br/>
                <p>Descrpition of yourself:</p>
                <FormControl htmlSize="26" as="textarea" aria-label="With textarea" />
                <br/>
                <br/>
                <div className="enseignement">
              <h3>  ENSEIGNEMENT</h3>
              <hr class="solid"/>

                <div style={{display:"flex"}}>
                <TextField  autoComplete="fname" variant="outlined" required type="name" fullWidth  id="name"
               label="Le nom de votre parcours d'etudes"
               style={{marginRight:"10px"}}
               autoFocus/>
 <TextField  variant="outlined" required type="date"   id="date"
               label="Date "
               autoFocus/>
                </div>
                <br/>
                <Button>Ajouter une nouvelle annee</Button>
               
                </div>
                
                

                <br/>
                <br/>
                <div className="exp">
               
              <h3>  EXPPERIENCE</h3>
              <hr class="solid"/>

                <div style={{display:"flex"}}>
                <TextField  autoComplete="fname" variant="outlined" required type="name" fullWidth  id="name"
               label="Le nom de votre experience "
               style={{marginRight:"10px"}}
               autoFocus/>
 <TextField  variant="outlined" required type="date"   id="date"
               label="Date "
               autoFocus/>
                </div>
                <br/>
                <Button>Ajouter une nouvelle Experience</Button>
                </div>
              
                <br/>
                <br/>
                <div className="competence">
                
                <h3>  INTERESTS</h3>
                <hr class="solid"/>

             
                <FormControl htmlSize="26" as="textarea" aria-label="With textarea" />

                <br/>
                <Button>Ajouter une nouvelle competence</Button>

                </div>
               
        </div>
    </nav>
</div>
        </div> 


</div><br/>
<Fab variant="extended" onClick={this.createPDF} id="pdf">
  <Icon.Download  />
  Download pdf?
</Fab><br/>
<br/>
<br/>

    </div>
)

}

}